import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SkipSelf,
} from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  UntypedFormGroup,
  ValidationErrors,
} from '@angular/forms';
import { InfoOption } from '@app/forms/subscription/components/info/info.component';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'joint-ownership-listing',
    templateUrl: './joint-ownership-listing.component.html',
    styleUrls: ['./joint-ownership-listing.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class JointOwnershipListingComponent implements OnInit, AfterViewInit {
  @Input() derrors: any = false;
  error: ValidationErrors = null;
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  constructor(
    private controlContainer: FormGroupDirective,
    private cd: ChangeDetectorRef,
  ) {}
  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  get form() {
    return this.controlContainer.form.get('parameters') as UntypedFormGroup;
  }

  ngOnInit() {
    this.cd.detectChanges();
  }
}
